import { render, staticRenderFns } from "./AddAccessGroupModal.vue?vue&type=template&id=37b5b2ee&"
import script from "./AddAccessGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddAccessGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports